import React from 'react'

import { StyleSheet, Text } from '@react-pdf/renderer'
import ErrorDataText from "../../ErrorDataText"

const styles = StyleSheet.create({
  variableContent: {
    color: 'black',
  },
})

const FrontierZoneVariableReport = ({ frontierZoneData }) => {

  if (!frontierZoneData) {
    return (
      <ErrorDataText contextName='FrontierZoneVariableReport' />
    )
  }

  return (
    <Text style={styles.variableContent}>
      {frontierZoneData.consists ? 'Reside em zona de fronteira.' : 'Não reside em zona de fronteira.'}
    </Text>
  )
}

export default FrontierZoneVariableReport
